export default __webpack_public_path__ + "static/media/upButtonCircle.d7a6e711.svg";